import { render, staticRenderFns } from "./MagazineSpellMaker.vue?vue&type=template&id=51369fdc&"
import script from "./MagazineSpellMaker.vue?vue&type=script&lang=js&"
export * from "./MagazineSpellMaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports